import { GlobalVariables } from '../../constants/globals';
import { ResourceContextType } from '../../model/base/annotation';

/**
 * Check if the context type (when provided) is trident workspace
 * @returns if the context type is trident workspace
 */
export function isTridentInIframe(): boolean {
    return (
        GlobalVariables.enableIFrameMode && GlobalVariables.isTrident
    );
}

/**
 * Check if the context type is mountedDataFactory
 * @returns if the context type is mountedDataFactory
 */
export function isMountedDataFactory(): boolean {
    return GlobalVariables.isMountedDf;
}

export function isDedicatedAdfInIframe(contextType: ResourceContextType): boolean {
    return GlobalVariables.enableIFrameMode && contextType === 'dedicatedAdfInIframe';
}
